module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.26459",
      "ably": "static-2.2",
      "conversations-async-data": "static-2.6750",
      "conversations-error-reporting": "static-1.8024",
      "conversations-internal-pub-sub": "static-1.15108",
      "conversations-internal-schema": "static-1.11738",
      "conversations-message-history": "static-1.10226",
      "conversations-test-sdk": "static-1.9566",
      "conversations-visitor-experience-components": "static-1.19822",
      "head-dlb": "static-1.4210",
      "hs-promise-utils": "static-1.4630",
      "hs-test-utils": "static-1.7102",
      "hubspot-dlb": "static-2.1406",
      "HubStyleTokens": "static-2.10622",
      "I18n": "static-7.1413",
      "jasmine-immutable": "static-1.2067",
      "jasmine-runner": "static-1.5525",
      "quartz": "static-1.5867",
      "react-aria": "static-1.42",
      "react-dlb": "static-1.56",
      "react-transition-group": "static-2.8",
      "redux-thunk": "static-2.43",
      "transmute": "static-2.29",
      "urlinator": "static-1.3645",
      "viral-links-lib": "static-1.5985",
      "visitor-ui-component-library": "static-1.5293",
      "webpack-env": "static-1.54",
      "ably-hubspot-js": "static-2.3671",
      "atom": "static-1.4254",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.3898",
      "conversations-infrastructure": "static-1.8045",
      "conversations-prop-types": "static-1.6556",
      "conversations-visibility-tools": "static-1.4878",
      "conversations-visitor-message-history": "static-1.18559",
      "cssUtils": "static-1.549",
      "enviro": "static-4.313",
      "flux-actions": "static-1.282",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.4807",
      "hubspot-url-utils": "static-1.3063",
      "immer": "static-1.33",
      "immutable": "static-2.19",
      "metrics-js": "static-1.8459",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.291",
      "raven": "static-3.5037",
      "react": "static-7.151",
      "react-dom": "static-7.85",
      "react-redux": "static-7.16",
      "react-rhumb": "static-1.15669",
      "react-select-plus": "static-1.65",
      "react-utils": "static-2.4564",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize": "static-1.3482",
      "sanitize-text": "static-1.7256",
      "signup-constants": "static-1.16963",
      "styled-components": "static-2.64",
      "StyleGuideUI": "static-3.470",
      "usage-tracker": "static-1.6568",
      "usage-tracker-core": "static-1.6418",
      "usage-tracker-multi": "static-1.4982",
      "usage-tracker-public": "static-1.6379",
      "visitor-ui-component-library-icons": "static-1.5104",
      "hs-promise-rejection-tracking": "static-1.4568",
      "raven-hubspot": "static-1.5344",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.2704",
      "moment": "static-3.26",
      "quartz-core": "static-1.5086",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.4005",
      "foundations-components": "static-1.6479",
      "foundations-theming": "static-1.3413",
      "UIComponents": "static-3.7569",
      "cv-backend-services": "static-1.1260",
      "immutable-less": "static-1.3661",
      "conversations-skeleton-state": "static-1.6471",
      "icons": "static-2.593",
      "react-input-autosize": "static-2.17",
      "react-virtualized": "static-2.77",
      "rpc-client-utils": "static-1.3841",
      "ui-images": "static-2.911",
      "permission-components": "static-1.4482",
      "HeadJS": "static-2.596",
      "framer-motion": "static-1.44",
      "hs-test-utils-bend-plugin": "static-1.2213",
      "msw": "static-1.39",
      "testing-library": "static-1.126",
      "i18n-data": "static-1.202",
      "moment-timezone": "static-5.51",
      "jasmine": "static-4.3453",
      "quartz-core-utils": "static-1.2734",
      "signup-ui-url-generator": "static-2.7165",
      "HubStyle": "static-2.10930",
      "sassPrefix": "static-1.136",
      "csstype": "static-1.38",
      "history": "static-4.47",
      "usage-tracker-anonymous": "static-1.4985",
      "copilot-toolkit": "static-1.8044",
      "dispatcher": "static-1.117",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.668",
      "hub-http-shared-msw-handlers": "static-1.7476",
      "hubspotter-http": "static-1.3827",
      "hubspotter-http-shared-msw-handlers": "static-1.7474",
      "mobile-manifest-mixins": "static-1.367",
      "platform-navigation-bootstrap": "static-1.11529",
      "quick-fetch": "static-1.2772",
      "react-router-dom": "static-5.26",
      "ui-fonts": "static-1.333",
      "hs-story-utils": "static-1.8468",
      "bend-plugin-foundations-components": "static-1.2748",
      "floating-ui": "static-1.32",
      "foundations-theming-specialty": "static-1.1130",
      "tanstack-table": "static-1.23",
      "bend-plugin-foundations-theming": "static-1.1896",
      "foundations-theming-base": "static-1.2398",
      "ts-schema": "static-1.3353",
      "chatspot-client-types": "static-1.9304",
      "chatspot-core": "static-1.17463",
      "platform-infra-nav-components": "static-1.6938"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.26459",
      "ably": "/ably/static-2.2",
      "conversations-async-data": "/conversations-async-data/static-2.6750",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.8024",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.15108",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.11738",
      "conversations-message-history": "/conversations-message-history/static-1.10226",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.9566",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.19822",
      "head-dlb": "/head-dlb/static-1.4210",
      "hs-promise-utils": "/hs-promise-utils/static-1.4630",
      "hs-test-utils": "/hs-test-utils/static-1.7102",
      "hubspot-dlb": "/hubspot-dlb/static-2.1406",
      "HubStyleTokens": "/HubStyleTokens/static-2.10622",
      "I18n": "/I18n/static-7.1413",
      "jasmine-immutable": "/jasmine-immutable/static-1.2067",
      "jasmine-runner": "/jasmine-runner/static-1.5525",
      "quartz": "/quartz/static-1.5867",
      "react-aria": "/react-aria/static-1.42",
      "react-dlb": "/react-dlb/static-1.56",
      "react-transition-group": "/react-transition-group/static-2.8",
      "redux-thunk": "/redux-thunk/static-2.43",
      "transmute": "/transmute/static-2.29",
      "urlinator": "/urlinator/static-1.3645",
      "viral-links-lib": "/viral-links-lib/static-1.5985",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5293",
      "webpack-env": "/webpack-env/static-1.54",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.3671",
      "atom": "/atom/static-1.4254",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.3898",
      "conversations-infrastructure": "/conversations-infrastructure/static-1.8045",
      "conversations-prop-types": "/conversations-prop-types/static-1.6556",
      "conversations-visibility-tools": "/conversations-visibility-tools/static-1.4878",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.18559",
      "cssUtils": "/cssUtils/static-1.549",
      "enviro": "/enviro/static-4.313",
      "flux-actions": "/flux-actions/static-1.282",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.4807",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3063",
      "immer": "/immer/static-1.33",
      "immutable": "/immutable/static-2.19",
      "metrics-js": "/metrics-js/static-1.8459",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.291",
      "raven": "/raven/static-3.5037",
      "react": "/react/static-7.151",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.16",
      "react-rhumb": "/react-rhumb/static-1.15669",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-utils": "/react-utils/static-2.4564",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize": "/sanitize/static-1.3482",
      "sanitize-text": "/sanitize-text/static-1.7256",
      "signup-constants": "/signup-constants/static-1.16963",
      "styled-components": "/styled-components/static-2.64",
      "StyleGuideUI": "/StyleGuideUI/static-3.470",
      "usage-tracker": "/usage-tracker/static-1.6568",
      "usage-tracker-core": "/usage-tracker-core/static-1.6418",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.4982",
      "usage-tracker-public": "/usage-tracker-public/static-1.6379",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5104",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4568",
      "raven-hubspot": "/raven-hubspot/static-1.5344",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2704",
      "moment": "/moment/static-3.26",
      "quartz-core": "/quartz-core/static-1.5086",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.4005",
      "foundations-components": "/foundations-components/static-1.6479",
      "foundations-theming": "/foundations-theming/static-1.3413",
      "UIComponents": "/UIComponents/static-3.7569",
      "cv-backend-services": "/cv-backend-services/static-1.1260",
      "immutable-less": "/immutable-less/static-1.3661",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6471",
      "icons": "/icons/static-2.593",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-virtualized": "/react-virtualized/static-2.77",
      "rpc-client-utils": "/rpc-client-utils/static-1.3841",
      "ui-images": "/ui-images/static-2.911",
      "permission-components": "/permission-components/static-1.4482",
      "HeadJS": "/HeadJS/static-2.596",
      "framer-motion": "/framer-motion/static-1.44",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2213",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.126",
      "i18n-data": "/i18n-data/static-1.202",
      "moment-timezone": "/moment-timezone/static-5.51",
      "jasmine": "/jasmine/static-4.3453",
      "quartz-core-utils": "/quartz-core-utils/static-1.2734",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7165",
      "HubStyle": "/HubStyle/static-2.10930",
      "sassPrefix": "/sassPrefix/static-1.136",
      "csstype": "/csstype/static-1.38",
      "history": "/history/static-4.47",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.4985",
      "copilot-toolkit": "/copilot-toolkit/static-1.8044",
      "dispatcher": "/dispatcher/static-1.117",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.668",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.7476",
      "hubspotter-http": "/hubspotter-http/static-1.3827",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.7474",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.367",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11529",
      "quick-fetch": "/quick-fetch/static-1.2772",
      "react-router-dom": "/react-router-dom/static-5.26",
      "ui-fonts": "/ui-fonts/static-1.333",
      "hs-story-utils": "/hs-story-utils/static-1.8468",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.2748",
      "floating-ui": "/floating-ui/static-1.32",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1130",
      "tanstack-table": "/tanstack-table/static-1.23",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.1896",
      "foundations-theming-base": "/foundations-theming-base/static-1.2398",
      "ts-schema": "/ts-schema/static-1.3353",
      "chatspot-client-types": "/chatspot-client-types/static-1.9304",
      "chatspot-core": "/chatspot-core/static-1.17463",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6938"
    },
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};